(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const lazyVideoWrappers = document.querySelectorAll('[data-lazy-video-wrapper]');

    if (!lazyVideoWrappers.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: do nothing special; videos will only load when user hits play
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const wrapper = entry.target;
          const video = wrapper.querySelector('video');

          if (!video) {
            obs.unobserve(wrapper);
            return;
          }

          // Start loading
          video.preload = 'auto';

          const shouldAutoplay = wrapper.dataset.autoplay === 'true';

          if (shouldAutoplay) {
            console.log('Attempting to autoplay video');
            video.play().catch(() => {
              // Ignore autoplay errors (e.g. user gesture required)
            });
          }

          // Only need to trigger once
          obs.unobserve(wrapper);
        });
      },
      {
        root: null,
        rootMargin: '200px 0px', // begin ~200px before viewport
        threshold: 0.1,
      }
    );

    lazyVideoWrappers.forEach((wrapper) => observer.observe(wrapper));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-action-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('contact-chat-trigger')) {
    customElements.define(
      'contact-chat-trigger',
      class ContactChatTrigger extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.label = this.querySelector('[data-chat-label]');
          this.status = document.getElementById(this.button?.getAttribute('aria-describedby'));
          this.button?.addEventListener('click', this.onClick.bind(this));
        }

        async onClick() {
          if (this.button.getAttribute('aria-busy') === 'true') return;
          if (typeof window.luxoOpenInsideChat !== 'function') return this.showUnavailable();

          this.button.setAttribute('aria-busy', 'true');
          this.label.textContent = 'Opening…';
          if (this.status) this.status.hidden = true;

          const opened = await window.luxoOpenInsideChat();

          this.button.removeAttribute('aria-busy');
          this.label.textContent = 'Chat';
          if (!opened) this.showUnavailable();
        }

        showUnavailable() {
          if (!this.status) return;
          this.status.textContent = 'Live chat is unavailable right now. Please call or email us instead.';
          this.status.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('contact-us')) {
    customElements.define(
      'contact-us',
      class ContactUs extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const chatButton = this.querySelector('.contact-us__chat-now-button');
          const ctaText = chatButton.querySelector('.contact-us__chat-now-button__cta-text');
          const openChat = async () => {
            if (chatButton.getAttribute('aria-busy') === 'true' || typeof window.luxoOpenInsideChat !== 'function') return;
            chatButton.setAttribute('aria-busy', 'true');
            ctaText.textContent = 'Opening…';
            const opened = await window.luxoOpenInsideChat();
            chatButton.removeAttribute('aria-busy');
            ctaText.textContent = opened ? 'Chat now' : 'Chat unavailable';
          };

          chatButton.addEventListener('click', openChat);
          chatButton.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            openChat();
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyHeaderHeader = this.header.querySelector('sticky-header > header');
      this.searchToggle = document.getElementById('search-toggle');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('change', this.setHeaderHeight.bind(this));
      this.header.querySelector('sticky-header').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.searchInput = this.predictiveSearch ? this.predictiveSearch.querySelector('#Search-In-Modal') : null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if(this.searchToggle)
        this.searchToggle.addEventListener('click', this.onSearchToggle.bind(this));

      this.createObserver();
      // Removing the auto show of search on first visit for causing increasing speed of Speed Index metric
      // if (!localStorage.getItem('hasVisited')) { //new user?
      //   localStorage.setItem('hasVisited', 'true');
      //   setTimeout(() => {
      //     this.onSearchToggle();
      //   }, 1000);
      // }
    }

    onSearchToggle() {
      this.stickyHeaderHeader.classList.toggle('search-open');
      // Auto focus the search input when opening the search modal
      if (this.stickyHeaderHeader.classList.contains('search-open') && this.searchInput) {
        this.searchInput.focus();
        document.querySelector('main#MainContent').style.setProperty('--sticky-header-height-mobile', '96px');
      }
      else
        document.querySelector('main#MainContent').style.removeProperty('--sticky-header-height-mobile');

    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      const stickyHeader = this.header.querySelector('sticky-header');
      // const stickyHeaderHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
      const stickyHeaderHeight = 44;
      document.documentElement.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      document.documentElement.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    initHeaderBounds(bounds) {
      document.body.classList.add('sticky-header');
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        const bounds = entries[0].intersectionRect;

        if (typeof this.initHeaderBounds === 'function') {
          this.initHeaderBounds(bounds);
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Check if top of page
      if (scrollTop > 0) {
        document.querySelector('body').classList.add('scrolled-from-top');
      } else {
        document.querySelector('body').classList.remove('scrolled-from-top');
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
